import axios from '../axios';
// 系统字典表查询
export const selectByAnyDictList = data => {
  return axios({
    url: '/api/sys/dict/getDictPage',
    method: 'post',
    data
  })
}

// 系统字典表添加
export const listAdd = data => {
    return axios({
      url: '/api/sys/dict/saveDict',
      method: 'post',
      data
    })
  }

  // 系统字典表修改
export const listUpdate = data => {
    return axios({
      url: '/api/sys/dict/updateDict',
      method: 'post',
      data
    })
  }

    // 系统字典表删除
export const listDel = data => {
    return axios({
      url: '/api/sys/dict/deleteDicts',
      method: 'post',
      data
    })
  }

    // 查询单条
export const getDict = data => {
    return axios({
        url: '/api/sys/dict/getDict',
        method: 'post',
        data
    })
}
// 根据字典类型获取字典值
export const getDictValue = data => {
  return axios({
    url: '/api/sys/dict/getDictValue',
    method: 'post',
    data
  })
}


// 枚举类型维护列表
export const getSysEnumCategoryPage = data => {
  return axios({
    url: '/api/sys/enum/category/getSysEnumCategoryPage',
    method: 'post',
    data
  })
}
// 枚举类型维护树状
export const getSysEnumCategoryTree = data => {
  return axios({
    url: '/api/sys/enum/category/getSysEnumCategoryTree',
    method: 'post',
    data
  })
}
export const saveSysEnumCategory = (data) => {
  // 枚举类型维护列表增
  if (!data.categoryId) {
    return axios({
      url: '/api/sys/enum/category/saveSysEnumCategory',
      method: 'post',
      data
    })
  } else { // 枚举类型维护列表改
    return axios({
      url: '/api/sys/enum/category/updateSysEnumCategory',
      method: 'post',
      data
    })
  }
}
// 枚举维护表列表
export const getSysEnumPage = data => {
  return axios({
    url: '/api/sys/enum/getSysEnumPage',
    method: 'post',
    data
  })
}
// 枚举维护表列表保存
export const saveSysEnum = data => {
  return axios({
    url: '/api/sys/enum/saveSysEnum',
    method: 'post',
    data
  })
}
// 枚举维护表列表修改
export const updateSysEnum = data => {
  return axios({
    url: '/api/sys/enum/updateSysEnum',
    method: 'post',
    data
  })
}
// 枚举维护表列表删除
export const deleteSysEnums = data => {
  return axios({
    url: '/api/sys/enum/deleteSysEnums',
    method: 'post',
    data
  })
}


// 仓库分组维护列表
export const getBaseStockGroupPage = data => {
  return axios({
    url: '/api/sys/getBaseStockGroupPage',
    method: 'post',
    data
  })
}
export const saveBaseStockGroup = (data) => {
  // 仓库分组维护列表保存
  if (!data.groupId) {
    return axios({
      url: '/api/sys/saveBaseStockGroup',
      method: 'post',
      data
    })
  } else { // 仓库分组维护列表修改
    return axios({
      url: '/api/sys/updateBaseStockGroup',
      method: 'post',
      data
    })
  }
}
// 仓库分组维护列表删除
export const deleteBaseStockGroups = data => {
  return axios({
    url: '/api/sys/deleteBaseStockGroups',
    method: 'post',
    data
  })
}
// 仓库列表
export const getBaseStockPage = data => {
  return axios({
    url: '/api/sys/getBaseStockPage',
    method: 'post',
    data
  })
}
// 仓库列表保存
export const saveBaseStock = data => {
  return axios({
    url: '/api/sys/saveBaseStock',
    method: 'post',
    data
  })
}
// 仓库列表修改
export const updateBaseStock = data => {
  return axios({
    url: '/api/sys/updateBaseStock',
    method: 'post',
    data
  })
}
// 仓库列表删除
export const deleteBaseStocks = data => {
  return axios({
    url: '/api/sys/deleteBaseStocks',
    method: 'post',
    data
  })
}
// 停用/启用仓库 status=0可用1停用
export const forbidBaseStock = data => {
  return axios({
    url: '/api/sys/forbidBaseStock',
    method: 'post',
    data
  })
}
// 开放授权密钥列表
export const getSysOpenApiPage = data => {
  return axios({
    url: '/api/sys/sys/open/api/getSysOpenApiPage',
    method: 'post',
    data
  })
}
// 保存开放授权密钥
export const saveSysOpenApi = data => {
  return axios({
    url: '/api/sys/sys/open/api/saveSysOpenApi',
    method: 'post',
    data
  })
}
// 修改开放授权密钥
export const updateSysOpenApi = data => {
  return axios({
    url: '/api/sys/sys/open/api/updateSysOpenApi',
    method: 'post',
    data
  })
}
// 删除开放授权密钥
export const deleteSysOpenApis = data => {
  return axios({
    url: '/api/sys/sys/open/api/deleteSysOpenApis',
    method: 'post',
    data
  })
}
// 重置开放授权密钥
export const resetSysOpenApi = data => {
  return axios({
    url: '/api/sys/sys/open/api/resetSysOpenApi',
    method: 'post',
    data
  })
}
// 开放授权密钥审批 auditFlag 1审批 0反审批
export const auditSysOpenApi = data => {
  return axios({
    url: '/api/sys/sys/open/api/auditSysOpenApi',
    method: 'post',
    data
  })
}
// 报警类型列表
export const getIotAlarmTypePage = data => {
  return axios({
    url: '/api/sys/iot/alarm/type/getIotAlarmTypePage',
    method: 'post',
    data
  })
}
// 保存报警类型
export const saveIotAlarmType = data => {
  return axios({
    url: '/api/sys/iot/alarm/type/saveIotAlarmType',
    method: 'post',
    data
  })
}
// 修改报警类型
export const updateIotAlarmType = data => {
  return axios({
    url: '/api/sys/iot/alarm/type/updateIotAlarmType',
    method: 'post',
    data
  })
}
// 删除报警类型
export const deleteIotAlarmTypes = data => {
  return axios({
    url: '/api/sys/iot/alarm/type/deleteIotAlarmTypes',
    method: 'post',
    data
  })
}
// 报警类型禁用 forbidStatus 1已禁用 0未禁用/启用
export const forbidIotAlarmTypes = data => {
  return axios({
    url: '/api/sys/iot/alarm/type/forbidIotAlarmTypes',
    method: 'post',
    data
  })
}
// 微信轮播图片类型的新增
export const saveSysEnumByWechatHone = data => {
  return axios({
    url: '/api/sys/enum/saveSysEnumByWechatHone',
    method: 'post',
    data
  })
}
// 微信轮播图片类型的修改
export const updateSysEnumByWechatHone = data => {
  return axios({
    url: '/api/sys/enum/updateSysEnumByWechatHone',
    method: 'post',
    data
  })
}
// 系统单据类型列表
export const getSysTableTypePage = data => {
  return axios({
    url: '/api/sys/sys/table/type/getSysTableTypePage',
    method: 'post',
    data
  })
}
// 系统单据类型列表
export const getSysTableTree = data => {
  return axios({
    url: '/api/sys/table/getSysTableTree',
    method: 'post',
    data
  })
}
// 保存系统单据类型
export const saveSysTableType = data => {
  return axios({
    url: '/api/sys/sys/table/type/saveSysTableType',
    method: 'post',
    data
  })
}
// 修改系统单据类型
export const updateSysTableType = data => {
  return axios({
    url: '/api/sys/sys/table/type/updateSysTableType',
    method: 'post',
    data
  })
}
// 删除系统单据类型
export const deleteSysTableTypes = data => {
  return axios({
    url: '/api/sys/sys/table/type/deleteSysTableTypes',
    method: 'post',
    data
  })
}
// 禁用系统单据类型
export const forbidSysTableTypes = data => {
  return axios({
    url: '/api/sys/sys/table/type/forbidSysTableTypes',
    method: 'post',
    data
  })
}
// 审核系统单据类型
export const auditSysTableTypes = data => {
  return axios({
    url: '/api/sys/sys/table/type/auditSysTableTypes',
    method: 'post',
    data
  })
}
// 系统表名
export const getSysTablePage = data => {
  return axios({
    url: '/api/sys/table/getSysTablePage',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/moudules/dictionary.js